
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("g0ZeR"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("g0ZeR", function(module, exports) {

let $ba8c2624cabd0252$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba8c2624cabd0252$var$load("h3ABO"),
    $ba8c2624cabd0252$var$load("fSobj"),
    $ba8c2624cabd0252$var$load("74u2y"),
    $ba8c2624cabd0252$var$load("2YffH"),
    $ba8c2624cabd0252$var$load("1aTst"),
    $ba8c2624cabd0252$var$load("6mHrv"),
    $ba8c2624cabd0252$var$load("awWN9"),
    $ba8c2624cabd0252$var$load("9CYct"),
    $ba8c2624cabd0252$var$load("bLsON"),
    $ba8c2624cabd0252$var$load("cPXmn"),
    $ba8c2624cabd0252$var$load("hZtKG"),
    $ba8c2624cabd0252$var$load("iNmaF"),
    $ba8c2624cabd0252$var$load("lVO3w"),
    $ba8c2624cabd0252$var$load("hyzoX"),
    $ba8c2624cabd0252$var$load("h9Ed7"),
    $ba8c2624cabd0252$var$load("eBRUf"),
    $ba8c2624cabd0252$var$load("b2zxR"),
    $ba8c2624cabd0252$var$load("tKhaz"),
    $ba8c2624cabd0252$var$load("5LRoP"),
    $ba8c2624cabd0252$var$load("2F8Ye"),
    $ba8c2624cabd0252$var$load("cD6Zr"),
    $ba8c2624cabd0252$var$load("dtASV"),
    $ba8c2624cabd0252$var$load("kWohI"),
    $ba8c2624cabd0252$var$load("8YSo7"),
    $ba8c2624cabd0252$var$load("g7ggm"),
    $ba8c2624cabd0252$var$load("Wowvf"),
    $ba8c2624cabd0252$var$load("9S9Mz"),
    $ba8c2624cabd0252$var$load("kiGNy"),
    $ba8c2624cabd0252$var$load("7do1E"),
    $ba8c2624cabd0252$var$load("77dkW"),
    $ba8c2624cabd0252$var$load("1MlIV"),
    $ba8c2624cabd0252$var$load("g9CVe"),
    $ba8c2624cabd0252$var$load("7oiUM"),
    $ba8c2624cabd0252$var$load("8t3po"),
    $ba8c2624cabd0252$var$load("855o0"),
    $ba8c2624cabd0252$var$load("8MfZE"),
    $ba8c2624cabd0252$var$load("hv4mn"),
    $ba8c2624cabd0252$var$load("dek7I"),
    $ba8c2624cabd0252$var$load("dYtBN"),
    $ba8c2624cabd0252$var$load("6wr18"),
    $ba8c2624cabd0252$var$load("kjZZD"),
    $ba8c2624cabd0252$var$load("8iA2F"),
    $ba8c2624cabd0252$var$load("4RhJO"),
    $ba8c2624cabd0252$var$load("jsqco"),
    $ba8c2624cabd0252$var$load("851iy"),
    $ba8c2624cabd0252$var$load("37ldp"),
    $ba8c2624cabd0252$var$load("ffEVr"),
    $ba8c2624cabd0252$var$load("dRpV3"),
    $ba8c2624cabd0252$var$load("dTsOE"),
    $ba8c2624cabd0252$var$load("hhss7"),
    $ba8c2624cabd0252$var$load("jwTn5"),
    $ba8c2624cabd0252$var$load("aYdgM"),
    $ba8c2624cabd0252$var$load("6u1hm"),
    $ba8c2624cabd0252$var$load("klApM"),
    $ba8c2624cabd0252$var$load("eQgf0"),
    $ba8c2624cabd0252$var$load("8fMw3"),
    $ba8c2624cabd0252$var$load("hogcU"),
    $ba8c2624cabd0252$var$load("74vOE"),
    $ba8c2624cabd0252$var$load("7EorR"),
    $ba8c2624cabd0252$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.2603f46c.js.map
